'use strict';

module.exports = function isIos(ua) {
  ua = ua || global.navigator.userAgent;
  return /iPhone|iPod|iPad/i.test(ua);
};



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/browser-detection/is-ios.js
// module id = 138
// module chunks = 0